import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';
import useAccountStore from '@/app/_stores/accountStore';
import { useToastStore } from '@/app/_stores/toastStore';
import { useLoggedInStore } from '@/app/_stores/loggedInStore';
import { ROUTER_PATH } from '@/app/_contants/routerPath';
import { memberQueries } from '@/app/_query/memberQueries';

const usePostLogout = () => {
  const queryClient = useQueryClient();
  const clearAccountInfo = useAccountStore.persist?.clearStorage || (() => {});

  const { addToast } = useToastStore();
  const { setIsLoggedIn } = useLoggedInStore();

  const router = useRouter();

  const goToMain = () => {
    router.push(ROUTER_PATH.MAIN);
  };

  return useMutation({
    ...memberQueries.logout(),
    onSuccess: () => {
      clearAccountInfo();
      setIsLoggedIn(false);
      queryClient.invalidateQueries({ queryKey: memberQueries.loggedInfo().queryKey });
      goToMain();
    },
    onError: () => {
      addToast('ログアウトに失敗しました。', 'error');
    },
  });
};

export default usePostLogout;
